var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "section-wrapper w-100" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "row align-items-end" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h2", { staticClass: "section-separator-title" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.lenderSubmit.applicationSummary"
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("direct-to-lender-app-summary", {
                attrs: { "read-only": "" },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card" },
          [
            _c(
              "div",
              {
                staticClass:
                  "card-header d-flex justify-content-between align-items-center",
              },
              [
                _c("h2", { staticClass: "section-separator-title" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.sectionTitle) + "\n        "
                  ),
                ]),
                _vm._v(" "),
                !_vm.showingLenderInformation
                  ? _c(
                      "b-button",
                      {
                        staticClass: "d-flex align-items-center",
                        attrs: { variant: "primary", size: "sm" },
                        on: {
                          click: function ($event) {
                            _vm.showingLenderInformation = true
                          },
                        },
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons mr-1",
                            staticStyle: { "font-size": "16px" },
                          },
                          [_vm._v("add")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "direct-to-lender.lenderSubmit.addManualResponse"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("incident-message", {
              attrs: { "service-name": "mpp" },
              on: { update: _vm.handleIncidentUpdate },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm.showingLenderInformation
                  ? _c("lender-information-section", {
                      attrs: { "submission-history": _vm.submissionHistory },
                      on: {
                        cancel: function ($event) {
                          _vm.showingLenderInformation = false
                        },
                        proceed: _vm.handleLenderInformationProceed,
                      },
                    })
                  : !_vm.showingResponseDetails
                  ? _c("response-information", {
                      ref: "responseInformation",
                      attrs: {
                        "lender-responses": _vm.lenderResponses,
                        mpp: _vm.mpp,
                        "generating-mpp": _vm.generatingMpp,
                        "mpp-disabled": _vm.mppDisabled,
                        "access-rights": _vm.accessRights,
                      },
                      on: {
                        "response-details": _vm.handleResponseDetails,
                        "response-accept": _vm.handleResponseAccept,
                        "response-preview": _vm.handleResponsePreview,
                        "response-download-mpp": _vm.handleResponseDownloadMpp,
                        "response-generate-mpp": _vm.handleResponseGenerateMpp,
                      },
                    })
                  : _c("response-details", {
                      attrs: {
                        "current-response": _vm.currentResponse,
                        "focused-element": _vm.focusedSection,
                      },
                      on: { back: _vm.handleBack },
                    }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("download-mpp-modal", {
        ref: "downloadMppModal",
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          "current-mpp": _vm.currentMpp,
          "selected-mpps": _vm.selectedMpps,
          "current-mpp-doc-downloading": _vm.currentMppDocDownloading,
          "downloading-mpp": _vm.downloadingMppDocuments,
          "previewing-mpp": _vm.previewingMpp,
        },
        on: {
          "select-mpp": _vm.handleSelectMpp,
          "download-mpp": _vm.handleDownloadMpp,
          "preview-mpp": _vm.handlePreviewMpp,
        },
      }),
      _vm._v(" "),
      _c("manual-response-modal", {
        ref: "manualResponseModal",
        attrs: {
          "application-data": _vm.currentManualApplicationData,
          "is-decision-accepted": _vm.manualResponseDecision === "approved",
          "client-username": _vm.clientUsername,
          "application-id": _vm.applicationId,
        },
        on: { hidden: _vm.reloadAfterManualResponse },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }